// extracted by mini-css-extract-plugin
export default {"container":"ProjectList_container__veXmg"};